//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled, { css } from 'styled-components';

import { FileUploader } from '@campaigns/components/shared/file-uploader/FileUploader';
import { FileUploaderAssetFailure } from '@campaigns/components/shared/file-uploader/FileUploaderTypes';
import { MAX_CATALOG_UPLOAD_SIZE_MB } from '@campaigns/constants/sampling/SamplingCampaignRequestConstants';
import { SAMPLING_CAMPAIGNS_TRACKING_ID } from '@campaigns/constants/sampling/SamplingCampaignsTrackingId';
import { downloadSamplingBulkUploadTemplate } from '@campaigns/hooks/useSamplingBulkUploadTemplateDownload';
import { PrimaryLinkButton } from '@components/atoms/button/Button';
import { BodyText } from '@components/atoms/text/Text';
import { SUPPORTED_NON_MEDIA_MIME_TYPES } from '@utils/mimeTypes';

interface DefaultViewProps {
  onFilesSelected: (files: File[], failures: FileUploaderAssetFailure) => void;
}

export const DefaultView = ({ onFilesSelected }: DefaultViewProps) => (
  <>
    <BodyText>
      Use the sample file to help you import new or existing products. &nbsp;
      <PrimaryLinkButton onClick={downloadSamplingBulkUploadTemplate}>
        Download sample file
      </PrimaryLinkButton>
    </BodyText>
    <StyledList>
      <StyledListItem>
        Make sure the file is in XLSX or CSV format
      </StyledListItem>
      <StyledListItem>Max file size 5MB</StyledListItem>
    </StyledList>
    <StyledFileUploader
      actionText='Click to select'
      existingAssetUrls={[]}
      maxTotalSize={MAX_CATALOG_UPLOAD_SIZE_MB}
      onFilesSelected={onFilesSelected}
      shouldAcceptMultipleFiles={false}
      supportedFileTypes={SUPPORTED_NON_MEDIA_MIME_TYPES}
      title='Drag and drop a CSV or Excel file here'
      trackingId={
        SAMPLING_CAMPAIGNS_TRACKING_ID.BULK_UPLOAD_MODAL_FILE_UPLOADER
      }
    />
  </>
);

const StyledList = styled.ul`
  ${({ theme }) => css`
    padding: 0 0 0 ${theme.spacings[3]};
    list-style-type: disc;
  `}
`;

const StyledListItem = styled.li`
  ${({ theme }) => css`
    margin: ${theme.spacings[2]} 0;
  `}
`;

const StyledFileUploader = styled(FileUploader)`
  ${({ theme }) => css`
    margin: ${theme.spacings[3]} auto 0;
    width: 100%;
  `}
`;
